// Share links: the whole graph travels in the URL hash (deflate + base64url)
// — a shared design needs no backend, and the recipient gets a live session,
// not a doc.

import { hydrate, save, snapshot } from "./persistence";
import { newSessionId, state } from "./state";

const b64url = (bytes: Uint8Array): string => {
  let s = "";
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export async function encodeSession(): Promise<string> {
  const cs = new CompressionStream("deflate-raw");
  const stream = new Blob([JSON.stringify(snapshot())]).stream().pipeThrough(cs);
  const bytes = new Uint8Array(await new Response(stream).arrayBuffer());
  return b64url(bytes);
}

export async function decodeSession(encoded: string): Promise<any> {
  const bin = atob(encoded.replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
  const ds = new DecompressionStream("deflate-raw");
  const stream = new Blob([bytes]).stream().pipeThrough(ds);
  return JSON.parse(await new Response(stream).text());
}

export async function shareLink(): Promise<string> {
  return `${location.origin}${location.pathname}#s=${await encodeSession()}`;
}

export async function importFromHash(): Promise<boolean> {
  const m = /^#s=([A-Za-z0-9_-]+)$/.exec(location.hash);
  if (!m) return false;
  try {
    const ok = hydrate(await decodeSession(m[1]!));
    if (ok) {
      state.sessionId = newSessionId();                    // fork into your own library entry
      save();
      history.replaceState(null, "", location.pathname);   // further edits are yours, not the link's
    }
    return ok;
  } catch { return false; }
}
